import styled from 'styled-components';

import { Link } from '../Link/Link';

export const Root = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  height: 100%;
  /* width: 286px; */
  text-align: left;
`;

export const ImageContainer = styled(Link)`
  position: relative;
  padding: 0;
`;

export const ImageCorner = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
`;

export const Image = styled.img`
  flex-shrink: 0;
  width: 100%;
  object-fit: cover;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding-bottom: 60px;
`;

export const Title = styled.h5`
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
`;

export const Desc = styled.span`
  display: block;
  margin: 6px 0 30px;
  padding: 0;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const Cta = styled(Link)`
  display: flex;
  align-items: center;
  gap: 7px;
  align-self: flex-start;
  margin-top: auto;
  width: fit-content;
  height: 32px;
  padding: 0 12px 0 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  border: 0 none;
  border-radius: 16px;
  transition: all 150ms;
`;
